<ng-container *ngIf="logado()">
  <section id="main-container">
    <app-topbar></app-topbar>
    <div id="container-menu-dashboard-footer">
      <app-menu></app-menu>
      <div class="container-icon">
        <em
          (click)="toggleMenu()"
          id="menu-icon"
          [style.right.px]="this.display() ? -10 : -17"
          [ngClass]="[
            this.display() ? 'pi pi-chevron-left' : 'pi pi-chevron-right'
          ]"></em>
      </div>
      <div id="main-content">
        <section id="dashboard-container" [style.min-height]="minHeight">
          <router-outlet></router-outlet>
        </section>
        <app-footer></app-footer>
      </div>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="!logado()">
  <router-outlet></router-outlet>
</ng-container>

<app-loading-page></app-loading-page>
<p-toast
  [baseZIndex]="10000"
  [preventOpenDuplicates]="true"
  key="global"></p-toast>
